import { Box, Checkbox, Input, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { EditFormIcon, TrashIcon } from "~misc/icons";
import TableContent from "../TableContent";

const FunnelDashboardSecundaryTable = ({ data, id, headerValues, layoutData, handleDelete }) => {
  return (
    <div className="funnel-table-container secundary-table">
      <Table className="funnel-table">
        <TableContent data={data} id={id} headerValues={headerValues} layoutData={layoutData} handleDelete={handleDelete} />
      </Table>
    </div>
  );
};

export default FunnelDashboardSecundaryTable;
